import React, { useMemo } from 'react';
import { UltraVoucherIcon } from '../../../../../utils/svg';
import { useSelector } from 'react-redux';

const PaymentMethod = () => {
	const { detail } = useSelector((store) => store?.order);
	const payment = detail?.request_post_datas?.payment || {};
	return (
		<>
			<div className='border-t-1 border-solid border-gray-200' />
			<div className='my-5'>
				<div className='text-xs text-gray-500 font-normal'>Metode Pembayaran</div>
				<div className='flex mt-5 items-center border-solid border-1 border-gray-300 p-4 rounded-lg'>
					<img alt={payment?.code ?? ''} src={payment?.image_url} className={`${payment?.image_size_payment || 'w-11'} h-auto object-contain object-center`} />
					<div className='pl-2 text-sm text-gray-700'>{payment?.name ?? ''}</div>
				</div>
			</div>
			<div className='border-b-1 border-solid border-gray-200' />
		</>
	);
};

export default PaymentMethod;
